// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1feiZ","col":"Table_col__1eo9A","fulfillmentStatus":"Table_fulfillmentStatus__WHYXj","emailCol":"Table_emailCol__2dQCt"};